var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 48,
    viewBox: "0 0 38 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eye",
    transform: "translate(-1836 -556)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_368",
    "data-name": "Rectangle 368",
    width: 38,
    height: 48,
    transform: "translate(1834 554)",
    fill: "#fff",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "eye-2",
    "data-name": "eye",
    transform: "translate(1844 574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "eye-3",
    "data-name": "eye",
    d: "M.088,10.128a.831.831,0,0,0,0,.745,14.557,14.557,0,0,0,.933,1.536,17.127,17.127,0,0,0,1.464,1.848A13.193,13.193,0,0,0,5.252,16.59,8.963,8.963,0,0,0,10,18a8.963,8.963,0,0,0,4.748-1.41,13.193,13.193,0,0,0,2.766-2.333,17.232,17.232,0,0,0,1.464-1.848,14.557,14.557,0,0,0,.933-1.536.831.831,0,0,0,0-.745,14.557,14.557,0,0,0-.933-1.536,17.127,17.127,0,0,0-1.464-1.848A13.193,13.193,0,0,0,14.748,4.41,8.963,8.963,0,0,0,10,3,8.963,8.963,0,0,0,5.252,4.41,13.193,13.193,0,0,0,2.486,6.743,17.046,17.046,0,0,0,1.022,8.592a14.556,14.556,0,0,0-.933,1.536Zm1.695.372c.136-.234.339-.567.612-.965A15.479,15.479,0,0,1,3.716,7.868a11.547,11.547,0,0,1,2.412-2.04A7.3,7.3,0,0,1,10,4.667a7.3,7.3,0,0,1,3.872,1.161,11.547,11.547,0,0,1,2.412,2.04A15.585,15.585,0,0,1,17.6,9.535c.273.4.477.73.612.965-.136.234-.339.568-.612.965a15.479,15.479,0,0,1-1.321,1.668,11.547,11.547,0,0,1-2.412,2.04A7.3,7.3,0,0,1,10,16.333a7.3,7.3,0,0,1-3.872-1.161,11.547,11.547,0,0,1-2.412-2.04A15.584,15.584,0,0,1,2.4,11.465c-.273-.4-.477-.731-.612-.965Zm11.55,0a3.335,3.335,0,1,0-.977,2.357A3.323,3.323,0,0,0,13.333,10.5Zm-1.667,0a1.667,1.667,0,1,1-.488-1.178A1.658,1.658,0,0,1,11.667,10.5Z",
    transform: "translate(0 -3)",
    fill: "#05152d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.f9b842195b1915e3c6bf1c43df03eaea.svg";
export { ForwardRef as ReactComponent };